import { ADYEN_API_URI } from './const';

export const updateAdyenPayment = async (
  transactionId: string,
  paymentData: string,
) => {
  try {
    const response = await fetch(`${ADYEN_API_URI}payment/update_amount`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        transaction_id: transactionId,
        payment_data: paymentData,
      }),
    });

    if (!response.ok) {
      return {
        code: response.status,
        msg: `HTTP error: ${response.status} ${response.statusText}`,
      };
    }

    return response.json();
  } catch (error) {
    return {
      code: -1,
      msg: 'Failed to update the payment amount',
    };
  }
};
